import { render, staticRenderFns } from "./patient-data.vue?vue&type=template&id=cb9e240a&scoped=true&"
import script from "./patient-data.vue?vue&type=script&lang=js&"
export * from "./patient-data.vue?vue&type=script&lang=js&"
import style0 from "./patient-data.vue?vue&type=style&index=0&id=cb9e240a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9e240a",
  null
  
)

export default component.exports